import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchDealerConfigOptions } from '../services/dealerConfigOptions';
import { dealerConfigOptionKeys } from './useDealerConfigOptionsQuery';

/**
 * Async combobox source over the dealer config-options catalog. Owned by P4a
 * (the catalog) but shared with P4b (the per-dealer settings panel), which
 * consumes it to build its config-option picker. Mirrors
 * `smr-admin/hooks/useConfigOptionsComboboxQuery.ts`.
 */
export function useDealerConfigOptionsComboboxQuery(params: {
  search: string;
  page: number;
  perPage?: number;
  /** When set, scopes the catalog query to a single group. Omitted = all groups. */
  group?: string;
}) {
  const perPage = params.perPage ?? 20;
  return useQuery({
    queryKey: [
      ...dealerConfigOptionKeys.combobox(),
      { search: params.search, page: params.page, perPage, group: params.group },
    ] as const,
    queryFn: () =>
      fetchDealerConfigOptions({
        // Explicit empty-string check so a search of "0" is still forwarded to
        // the backend (truthy-coerce would drop "0").
        search: params.search === '' ? undefined : params.search,
        page: params.page,
        per_page: perPage,
        group: params.group,
      }),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
